import { hero } from "../../lib/assets";

export const BannerThree = () => {
  return (
    <section className="banner-area-three">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-7 col-md-9 order-0 order-lg-2">
            <div
              className="banner-img-three"
              data-aos="fade-left"
              data-aos-delay="300"
            >
              <img src={hero.banner} alt="" className="main-img" />
              <img
                src={hero.business_growth}
                alt=""
                className="img-two"
                data-parallax='{"y" : 100 }'
              />
              <img
                src={hero.visual_data}
                width={90}
                alt=""
                className="img-three"
                data-parallax='{"x" : -100 }'
              />
            </div>
          </div>
          <div className="col-lg-5">
            <div className="banner-content-three">
              <h2 className="title" data-aos="fade-right" data-aos-delay="0">
                Kadle Global Private Limited
              </h2>
              <p data-aos="fade-right" data-aos-delay="300">
                Technology, Infrastructure, Agriculture & Renewable Energy
                Solutions.
              </p>
              {/* <form
                action="#"
                className="banner-form"
                data-aos="fade-right"
                data-aos-delay="600"
              >
                <input type="text" placeholder="E-mail Address" />
                <button type="submit">
                  <i className="flaticon-right-arrow"></i>
                </button>
              </form> */}
            </div>
          </div>
        </div>
      </div>
      <div className="banner-shape-wrap-three">
        <img src={hero.arrow} width={80} alt="" />
        <img src={hero.grid_shape} alt="" />
      </div>
    </section>
  );
};
